<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" v-if="queues" class="mt-1">
        <v-autocomplete
          label="Search for customer..."
          v-model="selectedQueueId"
          :items="queues"
          item-text="name"
          item-value="id"
          outlined
          
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-text-field
          label="Customer Reference"
          v-model="ticketNumber"
          outlined
        >
        </v-text-field>
        
      </v-col>

       <v-col cols="12" class="ml-1">
        
        <div class="d-flex align-center"
          v-if="ui.useEmail == true"
        >
          <h5 class="mr-2">MESSAGE</h5>
          <v-switch
          v-model="ui.useEmail"
          color="#31b0ed"  
          inset
          dense
          >
          </v-switch>
          <h5>EMAIL</h5>
        </div>
      </v-col>

      <v-col cols="12" class="mb-10 ml-1">
        <v-btn
          @click="ui.useEmail ? createEmailTask() : createMessageTask()"
          color="primary"
          :disabled="selectedQueueId == null ? true : false"
        >
          Start Off Call Work
        </v-btn>
      </v-col>


      <v-col cols="12">
        <v-alert
          class="mb-0"
          :type="ui.showAlertType"
          dense
          :value="ui.showAlert"
        >
          {{ ui.displayResponse }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
let conversationsApi = new platformClient.ConversationsApi();
let routingApi = new platformClient.RoutingApi();
let architectApi = new platformClient.ArchitectApi();
let usersApi = new platformClient.UsersApi();

export default {
  name: "OrgQueues",
  props: ["accessToken", "userEmail", "userOrg", "urlParams"],

  data: () => ({
    queues: null,
    skillId: null,
    selectedQueueId: null,
    selectedQueueName: null,
    ticketNumber: null,
    ui: {
      displayResponse: null,
      skillName: "Agent skill not assigned",
      showAlert: false,
      showAlertType: "success",
      useEmail: false,
    },
  }),
  created() {
    this.getUsersMe();
    this.getQueues();
    //this.getDataTableRows()
    console.log("OrgQueues component created");
    console.log(this.urlParams.useEmail);

  },
  watch: {
    selectedQueueId(selectedQueueId) {
      this.queues.forEach((q) => {
        if (q.id == selectedQueueId) {
          this.selectedQueueName = q.name;
        }
      });
    },
    urlParams: {
      handler(newParams) {
        console.log("URL params changed:", newParams);
        // check the useEmail parameter from URL params
        if (newParams.useEmail == "true") {
          this.ui.useEmail = true;
        } else {
          this.ui.useEmail = false;
        }
      },
      deep: true,
    },
    
  },
  methods: {
    getUsersMe() {
      let opts = {
        expand: ["skills"],
      };
      usersApi
        .getUsersMe(opts)
        .then((data) => {
          console.log(data);
          const userEmail = data.email;
          const skills = data.skills;
          skills.forEach((skill) => {
            if (skill.name == userEmail) {
              this.skillId = skill.id;
              this.ui.skillName = skill.name;
            }
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // CREATE TASK USING EMAIL OBJECT STARTS HERE
    createEmailTask() {
      console.log("creating task");

      let body = {
        queueId: this.selectedQueueId,
        provider: "TCC",
        direction: "OUTBOUND",
        toName: `WORK TASK ${this.selectedQueueName}`,
        subject: "WORK TASK",
        toAddress: `WORK TASK ${this.selectedQueueName}`,
        attributes: { ticketNumber: this.ticketNumber },
      };

      conversationsApi
        .postConversationsEmails(body)
        .then((response) => {
          console.log(`Task created successfully ${JSON.stringify(response)}`);
          this.ticketNumber = null
          this.selectedQueueId = null
        })
        .catch((error) => {
          console.log(`Task create failed`);
          console.log(error);
          if (error.message) {
            this.ui.showAlertType = "error";
            this.ui.displayResponse = error.message;
          } else {
            this.ui.showAlertType = "error";
            this.ui.displayResponse = "there was an error creating the task";
          }
          this.ui.showAlert = true;
        });
    },
    // CREATE TASK USING EMAIL OBJECT ENDS HERE
    // CREATE TASK USING MESSAGE OBJECT STARTS HERE
    createMessageTask() {
      console.log("creating task");
      this.ui.displayResponse = null;

      const guid = this.generateGuid();

      let body = {
        queueId: this.selectedQueueId,
        toAddress: `WORK TASK ${this.selectedQueueName} ${guid}`,
        toAddressMessengerType: "open",
      };

      conversationsApi
        .postConversationsMessages(body)
        .then((response) => {
          console.log(`Task created successfully ${JSON.stringify(response)}`);
          this.ui.showAlertType = "success";
          this.ui.displayResponse = `Task created successfully with ConversationID: ${response.id}`;
          this.ui.showAlert = true;

          // If Customer Reference field is populated, retrieve concersation and add attribute
          setTimeout(() => {
            if (this.ticketNumber) { 
              this.getConversation(response.id);
            } else {
              // Clear up input fields
              this.ticketNumber = null;
              this.selectedQueueId = null;
            }
          }, 2000);
        })
        .catch((error) => {
          console.log(`Task create failed`);
          console.log(error);
          if (error.message) {
            this.ui.showAlertType = "error";
            this.ui.displayResponse = error.message;
          } else {
            this.ui.showAlertType = "error";
            this.ui.displayResponse = "there was an error creating the task";
          }
          this.ui.showAlert = true;
        });
    },
    getConversation(conversationId) {
      console.log(`Retrieving Participants for conversation ${conversationId}`);
      conversationsApi
      .getAnalyticsConversationDetails(conversationId)
        .then((response) => {
          console.log(`Conversation retrieved successfully for conversation ${conversationId}`);
          console.log(response);
          
          let ParticipantId = response.participants[0].participantId;
          this.updateConversationAttributes(conversationId, ParticipantId);

          // clear input fields
          this.ticketNumber = null;
          this.selectedQueueId = null;
          })
          .catch((error) => {
            console.log(`Failed to retrieve conversation details for ${conversationId}`);
            console.log(error);
            this.ui.showAlertType = "error";
            this.ui.displayResponse = error.message || "Failed to retrieve conversation details";
        });
    },
    updateConversationAttributes(conversationId, ParticipantId) {
      console.log(`Updating attributes for conversation ${conversationId} and participant ${ParticipantId}`);
      let body = {
        attributes: {
          ticketNumber: this.ticketNumber,
        },
      };
      conversationsApi
        .patchConversationParticipantAttributes(conversationId, ParticipantId, body)
        .then((response) => {
          console.log(`Conversation attributes updated successfully for conversation ${conversationId}`);
          console.log(response);

          // Clear up input fields
          this.ticketNumber = null;
          this.selectedQueueId = null;
        })
        .catch((error) => {
          console.log(`Failed to update conversation attributes for ${conversationId}`);
          console.log(error);
          this.ui.showAlertType = "error";
          this.ui.displayResponse = error.messageParams.message || "Failed to update conversation attributes";
        });
    },
    // CREATE TASK USING MESSAGE OBJECT ENDS HERE
    getQueues() {
      console.log("Retrieving Queues");
      let opts = {
        pageNumber: 1,
        pageSize: 500,
      };
      routingApi
        .getRoutingQueues(opts)
        .then((response) => {
          console.log(`Queue retrieval success`);
          console.log(response);
          this.queues = response.entities;
        })
        .catch((error) => {
          console.log(`Queue retrieval failed`);
          console.log(error);
        });
    },
    getDataTableRows() {
      let datatableId = "548e03c6-a2fd-43a2-a16e-3e418e0a7669";
      let opts = {
        pageNumber: 1,
        pageSize: 200,
        showbrief: false,
      };
      console.log("Retrieving Datatable Rows");
      architectApi
        .getFlowsDatatableRows(datatableId, opts)
        .then((data) => {
          console.log(data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    generateGuid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
  },
};
</script>

<style>
  .v-input--switch:not(.v-input--switch--flat) .v-input--switch__thumb {
    color: #31b0ed;
  }

  .theme--light.v-input--switch .v-input--switch__track {
    color: #31b0ed;
  }

</style>
